export const language: any = {
  main: "Utama",
  ingredients: "Bahan-Bahan",
  ai_chef: "AI",
  favorites: "Favorit",
  menu: "Menu",
  get_start: "Mulai",
  title_first_1: "AI merekomendasikan resep berdasarkan usia",
  title_second_1: "Dari menu hingga resep, semuanya terorganisir sempurna",
  content_1: "Berhenti khawatir tentang menu dan kalori harian. Mulai sekarang, dapatkan rekomendasi dari Hey! Cooker",
  title_first_2: "Hari ini terasa dingin, Anda sudah bekerja keras.",
  title_second_2: "Bagaimana dengan makan sup tentara setelah bekerja?",
  content_2: "Temukan daging kaleng dan mie instan di kulkas Anda dan buat makan malam sederhana!",
  my_food_ingredients: "Tidak tahu mau masak apa?",
  btn_add_photo: "Pilih gambar atau ambil foto",
  my_food_reason: "Pilih bahan yang Anda miliki",
  btn_get_cooking: "Dapatkan Saran Resep AI",
  enriching_title: "Perkaya tubuh dan pikiran Anda",
  enriching: "Kumpulan resep",
  photo_registration_title: "Ambil foto atau struk untuk<br/>mendapatkan rekomendasi menu!",
  photo_registration_content: `Identifikasi bahan dengan AI dan<br/>analisis resep untuk menambah kesenangan memasak!`,  
  food_suggestions_title: "Bingung mau makan apa?",
  food_suggestions_sub_title: "Hidangan Tematik",
  our_interests_title: "Buat menu yang cocok untuk Anda dan keluarga!",
  our_interests_sub_title: "Pilih berdasarkan usia dan jenis kelamin.",
  favorite_title: "Beragam buku catatan memasak",
  weather_title: "Hidangan yang cocok untuk cuaca dingin",
  video_title: "Tonton video yang penuh warna",
  tag: {
    close: "Tutup",
    open: "Perluas"
  },
  no_data: "Tidak ada data",
  update_version_submit: "Perbarui sekarang",
  update_version_title: "Kami memiliki versi terbaru dari aplikasi.",
  update_version_content: "Untuk pengalaman penggunaan yang optimal, harap perbarui ke versi terbaru dari aplikasi.",
  close_btn: "Tutup",
  not_video_id: "Video tidak ada",
  favorite_login: "Masuk atau daftar untuk menyimpan daftar resep favorit Anda.",
  favorite_section_title: "Jangan lupa untuk meninjau resep yang disimpan",
  favorite_section_description: "Resep favorit saya",
  view_recipe: "Lihat resep dari bahan yang dipilih",
  my_ingredient: "Bahan saya",
  add_ingredient: "Tambahkan bahan saya",
  discover: "Temukan",
  my_cooker: "Dapur Saya",
  video_section_title: "Temukan dan rasakan melalui video",
  video_section_description: "Video masakan yang direkomendasikan",
  age_10: "Di bawah 10 tahun",
  age_10_to_20: "10-20 tahun",
  age_20_to_30: "20-30 tahun",
  age_30_to_40: "30-40 tahun",
  age_40_to_50: "40-50 tahun",
  age_more_50: "50+ tahun",
  suggest_section_title: "Hey! Cooker akan membantu Anda memilih",
  suggest_section_description: "Topik apa yang menarik minat Anda?",
  weather_title1: "Saran hari ini",
  weather_title2: "Makan apa ya di hari hujan dan dingin?",
  tasteSuggestion1: "Memuaskan selera Anda",
  tasteSuggestion2: "Rasa yang dibuat khusus untuk Anda",
  tasteTitle1: "Pedas <br />dan menggoda",
  tasteDescription1: "#tumis #panggang #hariminggu",
  tasteTitle2: "Segar dan <br />ringan",
  tasteTitle3: "Asam dan<br/> menyegarkan",
  tasteTitle4: "Harum - <br />manis",
  tasteTitle5: "Campuran dan <br />memikat",
  tasteDescription2: "#segar #serat #diet",
  tasteDescription3: "#asam #manis #menyenangkan",
  tasteDescription4: "#unik #biji #ajaib",
  tasteDescription5: "#rasa #nutrisi #perasaan",
  suggest_item_title1: "Masakan Sederhana",
  suggest_item_description1: `Sarapan dan makan siang sederhana<br/>Resep`,
  suggest_item_title2: "Diet",
  suggest_item_description2: `Rendah Karbohidrat<br/>Sangat Lezat`,
  suggest_item_title3: "Makanan Akhir Tahun",
  suggest_item_description3: `Makanan pesta di rumah`,
  suggest_item_title4: "Makanan Sehat",
  suggest_item_description4: `Untuk tubuh dan pikiran sehat<br/>Buatlah pilihan yang baik`,
  suggest_item_title5: "Camilan Sederhana",
  suggest_item_description5: `Makanan ringan untuk minum`,
  history: "Riwayat analisis gambar",
  community: {
    sub_title: "Masak bersama semua orang",
    title: "Hei! Pencarian komunitas Cooker",
    trending: "Tren",
    follow: "Diikuti",
    video: "Video",
    discover: "Temukan",
    no_data: "Tidak ada pembaruan baru dari komunitas Hey! Cooker",
    discover_post: "Mencari lebih banyak postingan di komunitas"
  },
  user_suggest_title1: "Saran hari ini",
  user_suggest_title2: "Saran Resep Acak",
}


